export const TENANT_SCREENING_CRITERIA_MOVE_IN_MINIMUM_DAYS_DEFAULT = 0;
export const TENANT_SCREENING_CRITERIA_MOVE_IN_DATE_RANGE_IN_DAYS_DEFAULT = 14;
